<template>
  <div class="min-h-screen bg-primary-100 flex">
    <TheSidebar />

    <div class="flex-1 lg:ml-64 flex flex-col min-h-screen min-w-0">
      <TheMobileHeader />

      <main class="flex-1 p-4 md:p-6 overflow-x-hidden overflow-y-auto min-w-0">
        <div :class="constrained ? 'max-w-5xl mx-auto' : ''">
          <slot />
        </div>
      </main>
    </div>
    <DebugPanel />
  </div>
</template>

<script setup lang="ts">
import TheSidebar from '~/components/layout/TheSidebar.vue'
import TheMobileHeader from '~/components/layout/TheMobileHeader.vue'
import DebugPanel from '~/components/ui/DebugPanel.vue'

defineProps<{ constrained?: boolean }>()
</script>
